import type { InvoiceModel } from '@/Models/InvoiceModel';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import { useTranslation } from 'react-i18next';
import Styles from './AmountsGrid.module.scss';

function AmountsGrid({ invoiceModel, newTotalAmount, newPatientAmount, totalCustomHonorarium, changeTotalAmount, changeAmountPatient, checkNumericOnly, getInvoiceInformation }: Readonly<{
    invoiceModel: InvoiceModel; newTotalAmount: string; totalCustomHonorarium: string; newPatientAmount: string; changeTotalAmount: Function; changeAmountPatient: Function; checkNumericOnly: Function; getInvoiceInformation: Function;
}>): React.ReactElement {
    const { t } = useTranslation();

    return (
        <Grid container size={12} id="invoiceSummary" className={Styles.invoiceSummaryContainer} sx={{ all: 'initial' }}>
            <input type="hidden" name="CustomHonorarium" id="CustomHonorarium" value={totalCustomHonorarium} />
            <input type="hidden" name="CustomWIGW" id="CustomWIGW" value={totalCustomHonorarium} />
            <input type="hidden" name="CustomOther" id="CustomOther" value={totalCustomHonorarium} />
            <input type="hidden" name="CustomPractice" id="CustomPractice" value={totalCustomHonorarium} />
            {
                invoiceModel.CompanyPays

                    ? (
                            <>
                                <Grid size={3} className={`${Styles.summaryField} summaryField clearfix`} sx={{ all: 'initial' }}>
                                    {t('Amount')}
                                    {' '}
                                    {t('Patient')}
                                    <br />
                                    <span className="amountField clearfix">€ {invoiceModel.AmountPatient}</span>
                                </Grid>
                                <Grid size={3} className={`${Styles.summaryField} ${Styles.activeSummaryField} summaryField clearfix activeSummaryField`} sx={{ all: 'initial' }}>
                                    {t('TotalAmount')}
                                    <br />
                                    <p className={`${Styles.amountField} amountField clearfix`}>
                                        <span className="iconHolder">&euro;</span>
                                        <TextField
                                            slotProps={{ htmlInput: { className: 'cleanInput dis' } }}
                                            name="NewTotalAmount"
                                            type="text"
                                            value={newTotalAmount}
                                            onChange={(e) => changeTotalAmount(e.target.value)}
                                            onKeyDown={(e) => checkNumericOnly(e, newTotalAmount)}
                                            onBlur={(_) => getInvoiceInformation()}
                                        />
                                        <span className="refreshTotalAmount refresh" title={t('Reset') ?? 'Reset'}>&nbsp;</span>
                                    </p>
                                </Grid>
                            </>
                        )
                    : (
                            <>
                                <Grid size={3} className={`${Styles.summaryField} ${Styles.activeSummaryField} summaryField clearfix activeSummaryField`} sx={{ all: 'initial' }}>
                                    {t('Amount')}
                                    {' '}
                                    {t('Patient')}
                                    <br />
                                    <p className={`${Styles.amountField} amountField clearfix`}>
                                        €
                                        {' '}
                                        <input
                                            type="text"
                                            className="cleanInput dis"
                                            name="NewAmountPatient"
                                            value={newPatientAmount}
                                            style={{ color: '#FFF', borderColor: '#FFF' }}
                                            onChange={(e) => changeAmountPatient(e.target.value)}
                                            onKeyDown={(e) => checkNumericOnly(e, newPatientAmount)}
                                            onBlur={(e) => getInvoiceInformation()}
                                        />
                                        <span className="refreshAmountPatient refresh" title={t('Reset') ?? 'Reset'}>&nbsp;</span>
                                    </p>
                                </Grid>
                                <Grid size={3} className={`${Styles.summaryField} summaryField clearfix`} sx={{ all: 'initial' }}>
                                    {t('TotalAmount')}
                                    <br />
                                    <span className="amountField clearfix">€ {invoiceModel.TotalPractice}</span>
                                </Grid>
                            </>
                        )
            }

            <Grid size={3} className={`${Styles.summaryField} summaryField clearfix`} sx={{ all: 'initial' }}>
                {t('PatientShare')}
                <br />
                <span className="amountField clearfix">€ {invoiceModel.ThirdPayerPatientShare.toFixed(2)}</span>
            </Grid>
            <Grid size={3} className={`${Styles.summaryField} summaryField clearfix`} sx={{ all: 'initial' }}>
                {t('HealthInsuranceShare')}
                <br />
                <span className="amountField clearfix">€ {invoiceModel.ThirdPayerHealthInsuranceShare.toFixed(2)}</span>
            </Grid>
        </Grid>
    );
}
export default AmountsGrid;
